export default function validator() {
    'ngInject'

    // return $resource('/common/data/appInfo.json');
    const self = {}
    self.ruleSet = []
    self.set = function (state, dependRule, showMsg) {
        const vaildItem = {} // 包含set 中的三个参数 可以用 es6的类来实现
        vaildItem.state = state
        vaildItem.dependRule = dependRule
        vaildItem.showMsg = showMsg
        self.ruleSet.push(vaildItem)
    }
    self.verify = function (vaildItem) {
        let ret = false
        const { state } = vaildItem
        if (!state) {
            return true
        }
        const inputVal = state.$modelValue
        const rules = vaildItem.dependRule
        const show = vaildItem.showMsg
        // 默认验证

        if (state.$invalid) {
            // 验证未通过
            const keys = Object.keys(state.$error)
            let erromsg = ''
            console.log(keys[0])
            switch (keys[0]) {
            case 'email':
                erromsg = '必须为邮箱格式'
                break
            case 'number':
                erromsg = '必须为数字格式'
                break
            case 'required':
                erromsg = '必填项'
                break
            case 'pattern':
                erromsg = '正则匹配失败'
                break
            default:
                erromsg = '验证失败'
            }
            show(erromsg)
            return ret
        }
        // 自定义条件验证
        // for (const a in rules) {
        //     if (rules[a].condition(inputVal)) {
        //         show(rules[a].erromsg)
        //         return ret
        //     }
        // }
        if(rules){
            for (let a = 0; a < rules.length; a++) {
                if (rules[a].condition(inputVal)) {
                    show(rules[a].erromsg)
                    return ret
                }
            }
        }
        return ret = true
    }
    self.run = function (formName) {
        let flag = true
        const ruleSet = []
        for (const a in self.ruleSet) {
            ruleSet.push(self.verify(self.ruleSet[a]))
        }
        for (const i in ruleSet) {
            if (!ruleSet[i]) { flag = false; break }
        }
        return flag
    }
    self.reset = function () {
        self.ruleSet = []
    }
    return self
}

// service 是个单例 不会再次被实例化
// export default class validator  {
//     constructor () {
//         this.ruleSet = [];

//     }
//     set (validState,  dependRule, showMsg) {
//         let vaildItem = {}; //包含set 中的三个参数 可以用 es6的类来实现
//         vaildItem.validState =validState;
//         vaildItem.dependRule =dependRule;
//         vaildItem.showMsg =showMsg;
//         this.ruleSet.push(vaildItem);

//     }
//     verify (vaildItem) {
//     }
//     run () {
//        for(var a in this.ruleSet) {
//             this.verify(this.ruleSet[a]);
//        }
//     }
//     reset () {
//         this.ruleSet = [];
//     }
// }



// WEBPACK FOOTER //
// ./src/components/formvalidate/validator.js